import axios from "axios";

const api = axios.create({
    //    baseURL: process.env.REACT_APP_API_URL,
    //    baseURL: 'https://testmachine.tail02c94b.ts.net/api',
    //    baseURL: 'https://mc-ubuntu.tail02c94b.ts.net/api',
    baseURL: 'https://uragate.in/websites/webapi2',
});

const interceptorIds = { request: null, response: null };

export const setupInterceptor = (token) => {
    if (interceptorIds.request !== null) {
        api.interceptors.request.eject(interceptorIds.request);
    }
    if (interceptorIds.response !== null) {
        api.interceptors.response.eject(interceptorIds.response);
    }

    interceptorIds.request = api.interceptors.request.use(config => {
        config.headers.Authorization = `Bearer ${token}`;

        const auth = JSON.parse(localStorage.getItem('auth') || '{}');
        if (auth.refreshToken) {
            config.headers['x-refresh-token'] = auth.refreshToken;
        }

        return config;
    });

    interceptorIds.response = api.interceptors.response.use(
        response => {
            const newToken = response.headers['x-new-token'];
            if (newToken) {
                const auth = JSON.parse(localStorage.getItem('auth') || '{}');
                localStorage.setItem('auth', JSON.stringify({ ...auth, token: newToken }));
                setupInterceptor(newToken);
            }
            return response;
        },
        error => {
            if (error.response?.data?.code === 'SESSION_EXPIRED') {
            }
            return Promise.reject(error);
        },
    );
};

export default api;